var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animals-wrap",style:({left: _vm.left+'px'})},[(_vm.showPiggy)?_c('div',{staticClass:"piggy piggy_walk"}):_vm._e(),(_vm.showChicken)?_c('div',{staticClass:"chicken chicken_walk"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }